// Swaps legacy Bull Shot gallery image files for their new Shopify CDN
// equivalents, without touching any image outside the product gallery.
const SLIDER_CONTAINER = ".product-gallery__container";

// [oldFile, newBaseUrl, version]
const REPLACEMENTS = [
  [
    "BullShot-Shopify-Main-min.webp",
    "https://cdn.shopify.com/s/files/1/0688/6457/3493/files/IMG-01.jpg",
    "1783337751",
  ],
  [
    "BullShot-BBQ_1.jpg",
    "https://cdn.shopify.com/s/files/1/0688/6457/3493/files/IMG-01_1.jpg",
    "1783338725",
  ],
  [
    "BullShot-Degreaser.jpg",
    "https://cdn.shopify.com/s/files/1/0688/6457/3493/files/IMG-01_2.jpg",
    "1783338882",
  ],
];

const buildUrl = (base, version, size) =>
  `${base}?v=${version}&crop=center&height=${size}&width=${size}`;

const findReplacement = (src) =>
  REPLACEMENTS.find(([oldFile]) => src.indexOf(oldFile) !== -1);

const preloadReplacementImages = () => {
  REPLACEMENTS.forEach(([, base, version]) => {
    [150, 1500].forEach((size) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = buildUrl(base, version, size);
      document.head.appendChild(link);
    });
  });
};

const swapImage = (img) => {
  const src = img.getAttribute("src") || "";
  const replacement = findReplacement(src);
  if (!replacement) return;

  const [, base, version] = replacement;
  const size = src.indexOf("height=150&") !== -1 ? 150 : 1500;

  img.removeAttribute("srcset");
  img.removeAttribute("data-srcset");
  img.src = buildUrl(base, version, size);
  if (img.dataset.srcTemplate) {
    img.dataset.srcTemplate = buildUrl(base, version, 150);
  }
};

const initBullshotGalleryImageSwap = () => {
  const container = document.querySelector(SLIDER_CONTAINER);
  if (!container) return;

  const hasTargetImage = Array.from(container.querySelectorAll("img")).some(
    (img) => Boolean(findReplacement(img.getAttribute("src") || "")),
  );
  if (!hasTargetImage) return;

  preloadReplacementImages();
  container.querySelectorAll("img").forEach(swapImage);

  // Catches slides Swiper duplicates/re-renders after gallery init.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.tagName === "IMG") swapImage(node);
        else if (node.querySelectorAll) node.querySelectorAll("img").forEach(swapImage);
      });
    });
  });
  observer.observe(container, { childList: true, subtree: true });

  window.addEventListener("load", () => {
    setTimeout(() => observer.disconnect(), 1000);
  });
};

export { initBullshotGalleryImageSwap };
